import React, { useState } from 'react'
import { connect } from 'react-redux'

import SHSForm from '../../../utils/shs-form'
import InputElement from '../../../utils/input'
import SearchComplete from '../../../utils/search-complete'
import * as MASKS from '../../../utils/input-masks'
import { formatCurrency } from '../../../utils/formatters'

import { callApi } from '../../../../actions/api'
import { apiResourceEndpoint } from '../../../../constants/routes'

const CreateReceipt = ({ dispatch }) => {
    const [vendorId, setVendorId] = useState(null)
    const [vendorName, setVendorName] = useState('')
    const [gross, setGross] = useState('0')
    const [fees, setFees] = useState('0')

    const renderPhotoResult = (result) => {
        return (
            <>{result.name}</>
        )
    }

    const handleSelectResult = (result) => {
        setVendorId(result.id)
        setVendorName(result.name)
        console.log(vendorName)
    }

    const submitFX = (formData, formId) => {
        formData.vendorId = vendorId
        dispatch(callApi(apiResourceEndpoint('admin/receipts', 'CREATE'), formData, formId))
    }

    const successFX = () => {
        // not sure yet? maybe reset form?
    }

    return (
        <div>
            <h1>Create New Commission Receipt</h1>
            <p>Use the form below to create a new recipt</p>
            <SHSForm submitFX={submitFX} successFX={successFX}>
                <label>Vendor</label>
                <SearchComplete
                    placeholder="Search for a Vendor"
                    searchEndpoint="admin/vendors"
                    extraClass="form-control"
                    renderTemplate={renderPhotoResult}
                    onHandleSelect={handleSelectResult}
                    allowCreation={false} />
                {vendorName && <p>Selected Vendor: {vendorName}</p>}
                <InputElement
                    type="hidden"
                    id="vendorId"
                    value={vendorId}
                    label={null}
                    extraClass="d-none" />
                <InputElement
                    type="text"
                    id="gross"
                    label="Gross Amount"
                    isFormatted={true}
                    onChange={(key, value) => setGross(value)}
                    placeholder="$1,234.56"
                    formatMask={MASKS.dollarMask}
                    required />
                <InputElement
                    type="text"
                    id="fees"
                    label="Any Fees"
                    isFormatted={true}
                    onChange={(key, value) => setFees(value)}
                    placeholder="$1,234.56"
                    formatMask={MASKS.dollarMask}
                    default="0"
                    required />
                <InputElement
                    type="date"
                    id="receivedOn"
                    label="Received On Date"
                    required />
                <p>
                    Total: {formatCurrency(Number(gross) - Number(fees), 2, 2)}
                </p>
            </SHSForm>
        </div>
    )
}

export default connect()(CreateReceipt)
